import { Routes } from '@angular/router'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { SecuritySettingsComponent } from './security-settings.component'

export const searchRoutes: Routes = [
  {
    path: 'admin/settings/security_settings',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: SecuritySettingsComponent,
        data: {
          permissions: {
            only: 'SYSTEM_SETTINGS',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
